import { render, staticRenderFns } from "./UserRegistration.vue?vue&type=template&id=ca2ba8e0&scoped=true&"
import script from "./UserRegistration.vue?vue&type=script&lang=js&"
export * from "./UserRegistration.vue?vue&type=script&lang=js&"
import style0 from "./UserRegistration.vue?vue&type=style&index=0&id=ca2ba8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2ba8e0",
  null
  
)

export default component.exports